export const lineFormatted = line => {
  const lineFormatted = line.toFixed(1);
  return line > 0 ? `+${lineFormatted}` : lineFormatted;
};
